import request from '@/Utilities/httpRequest';
import utilities from '@/Utilities/common';
import operatingSystem from '@/Utilities/operating-system';
import apiCombos from '@/api/combos';
import websiteEvents from '@/Utilities/website-events';
import {throttle, isEmpty} from 'lodash-es';
import pdpUtils from '@/store/product-page/pdp-utils';

import moduleAddToCartMobile from '@/store/product-page/mobile-blackrabbit/add-to-cart-module';
//import {storePdp} from "@/store/product-page";


function initialState() {
    return {
        loadUrl: null, // for changing page data on groupId option change
        lastOrderUrl: null,
        pointsUrl: null,
        prozisPointsUpdateUrl: null,
        imagesUrl: null,
        headerData: {},
        isLoading: false,
        isLoadingCombos: false,
        preloadImage: {
            title: '',
            src: '',
            srcset: '',
            srcWebp: '',
            srcsetWebp: '',
            loadingImage: '',
        },
        criteoData: null,
        deviceDimensions: {
            screenWidth: 360,
            screenHeight: 667,
        },
        showRotateDevice: false,
        blockImageRecords: [],
        basicInfoData: {},
        infoSectionData: {},
        addToCartData: null,
        canCheckCombos: false,
        comboData: null,
        campaignsConnection: null,
        campaignsData: null,
        tabsData: null,
        relatedProductsBlocks: null,
        productUnavailableBlocks: null,
        isAppStore: false,
        isAppAndroid: false,
        isAppIOS: false,
        showNavBar: false,
        miniPdpMode: false,
        productDetailBlocks: null,
        productSocialBlocks: null,
        updateDescription: null,
        enableSideDetails: false,
        enableReverseSideDetails: false,
        enableStockAlert: false,
        fixedNavbar: false
    };
};

const pdpMobile = {
    strict: true,
    namespaced: true,
    state: initialState,
    mutations: {
        setLoadUrl(state, payload) {
            state.loadUrl = payload;
        },
        isLoading(state, payload) {
            state.isLoading = payload;
        },
        isLoadingCombos(state, payload) {
            state.isLoadingCombos = payload;
        },
        setPreloadImage(state, payload) {
            state.preloadImage = payload;
        },
        setLastOrderUrl(state, payload) {
            state.lastOrderUrl = payload;
        },
        setImagesUrl(state, payload) {
            state.imagesUrl = payload;
        },
        setHeaderData(state, payload) {
            state.headerData = payload;
        },
        setProzisPointsUpdateUrl(state, payload) {
            state.prozisPointsUpdateUrl = payload;
        },
        setPointsUrl(state, payload) {
            state.pointsUrl = payload;
        },
        setCriteoData(state, payload) {
            state.criteoData = payload;
        },
        setDeviceDimensions(state) {
            const screenVw = window.screen.width;
            const screenVh = window.screen.height;
            if(screenVw > state.deviceDimensions.screenWidth) {
                state.deviceDimensions.screenWidth = screenVw;
            }
            if(screenVh > state.deviceDimensions.screenHeight) {
                state.deviceDimensions.screenHeight = screenVh;
            }
        },
        setShowRotateDevice(state, payload) {
            state.showRotateDevice = payload;
        },
        setBlockImageRecords(state, payload) {
            state.blockImageRecords = payload;
        },
        setBasicInfoData(state, payload) {
            state.basicInfoData = payload;
        },  
        setInfoSectionData(state, payload) {
            const addToCartData = state.addToCartData;
            const productInfo = addToCartData.productInfo;
            const kStrings = addToCartData.kStrings;
            state.infoSectionData = {
                name: productInfo.name,
                groupId: productInfo.groupId,
                ratingData: {
                    rating: productInfo.rating,
                    totalRatings: productInfo.ratingTotal,
                },
                points: productInfo.points,
                superPoints: productInfo.superPoints,
                prozisPointsFactor: productInfo.pointsFactor ?? 1,
                priceData: {
                    price: productInfo.minPrice,
                    priceCrossed: productInfo.pricePartner,
                    bestPriceCoupon: productInfo.bestPriceCoupon,
                },
                showLinkComments: productInfo.showLinkComments,
                stockMsg: addToCartData.hasStock ? kStrings.kIN_STOCK : kStrings.kPROD_STOCK_OUT,
                sharedData: !isEmpty(addToCartData.sharedData) ? addToCartData.sharedData : null,
                likesData: !isEmpty(addToCartData.likesData) ? addToCartData.likesData : null,
                fanLinkData: addToCartData.fanLink,
                frozenText: addToCartData.isFrozen || productInfo.isFrozen ? kStrings.kPRODUTO_CONGELADO : null,
            };
        }, 
        updateInfoSectionPartial(state, payload) {
            state.infoSectionData = Object.assign({}, state.infoSectionData, payload);
        },
        setAddToCartData(state, payload) {
            state.addToCartData = payload;
        },
        setTabsData(state, payload) {
            state.tabsData = payload;
        },
        setCanCheckCombos(state, payload) {
            state.canCheckCombos = payload;
        },
        setComboData(state, payload) {
            state.comboData = payload;
        },
        setCampaignsConnection(state, payload) {
            state.campaignsConnection = payload;
        },
        setCampaignsData(state, payload) {
            state.campaignsData = payload;
        },
        setRelatedProductsBlocks(state, payload) {
            state.relatedProductsBlocks = payload;
        },
        setProductUnavailableBlocks(state, payload) {
            state.productUnavailableBlocks = payload;
        },
        setIsAppStore(state, payload) {
            state.isAppStore = payload;
        },
        setIsAppAndroid(state, payload) {
            state.isAppAndroid = payload;
        },
        setIsAppIOS(state, payload) {
            state.isAppIOS = payload;
        },
        setShowNavBar(state, payload) {
            state.showNavBar = payload;
        }, 
        setMiniPdpMode(state, payload) {
            state.miniPdpMode = payload;
        },
        updateLike(state, payload) {
            state.infoSectionData.likesData.liked = payload.like;
        },
        setProductDetailBlocks(state, payload) {
            state.productDetailBlocks = payload;
        },
        setProductSocialBlocks (state, payload) {
            state.productSocialBlocks = payload;
        },
        setUpdateDescription(state, payload) {
            state.updateDescription = payload;
        },
        setEnableSideDetails(state, payload) {
            state.enableSideDetails = payload;
        },
        setEnableReverseSideDetails(state, payload) {
            state.enableReverseSideDetails = payload;
        },
        setEnableStockAlert(state, payload) {
            state.enableStockAlert = payload;
        },
        setFixedNavbar(state, payload) {
            state.fixedNavbar = payload;
        },
        reset(state){
          // acquire initial state
          const s = initialState()
          Object.keys(s).forEach(key => {
            state[key] = s[key]
          });
        }
    },

    actions: {
        // state, commit, dispatch, rootState, rootGetters
        initWsData(context, payload, dispatch, rootState, rootGetters) {
            //console.log('init Page PLAYLOAD: ', payload);
            try {
                context.dispatch('updateKstrings', payload.addToCart.kStrings, {root: true});
                context.commit('setLoadUrl', payload.loadUrl);
                context.dispatch('updateLastOrderUrl', payload);
                if(payload.gallery){
                    context.commit('gallery/setImagesUrl', payload.gallery.url, {root: true});
                }
                context.commit('setHeaderData', payload.headerData);
                context.commit('setProzisPointsUpdateUrl', payload.prozisPointsUpdateUrl);
                context.commit('setPointsUrl', payload.pointsUrl);
                context.commit('setCriteoData', payload.criteoData);
                context.commit('setDeviceDimensions');
                //context.dispatch('matchWith/setData', payload.addToCart.matchWith, {root: true});
                context.commit('setBasicInfoData', payload.basicInfo);
                context.commit('setAddToCartData', payload.addToCart);
                context.commit('setInfoSectionData', payload);

                // reset campaign data
                context.commit('setCampaignsData', null);
                // update campaign data URL (backend will return null if product is disabled or out of stock)
                context.commit('setCampaignsConnection', payload.campaigns);
                
                context.commit('setTabsData', payload.tabs);
                context.commit('setIsAppStore', payload.isAppStore);
                context.commit('setIsAppAndroid', payload.isAppAndroid);
                context.commit('setIsAppIOS', payload.isAppIOS);
                context.commit('setMiniPdpMode', payload.miniPdpMode);
                if(payload.hasOwnProperty('blocksColor') && payload.blocksColor) {
                    context.dispatch('updateBlocksColor', payload.blocksColor, {root: true});
                }
                // base main store update
                const productInfo = payload.addToCart.productInfo;
                const isMiniPdpMode = context.getters.miniPdpMode;
                context.dispatch('priceCoupons/setData', payload.bestPriceCoupons ? payload.bestPriceCoupons : [], {root: true});
                if(payload.autoApplyCoupons){
                    // this should be set only one time, it's missing in AJAX requests 
                    context.dispatch('priceCoupons/setAutoApply', payload.autoApplyCoupons, {root: true});
                }
                context.dispatch('changeGroupId', {id: productInfo.groupId, masterSku: productInfo.sku}, {root: true});
                context.dispatch('gallery/setSKU', productInfo.sku, {root: true});
                context.dispatch('gallery/setGroupId', productInfo.groupId, {root: true});
                if(payload.gallery){
                    context.dispatch('gallery/updateData', payload.gallery, {root: true});
                }
                context.dispatch('addToCartMobile/updateShowQuantityWidget', productInfo.showQuantity)
                if (!isMiniPdpMode && payload.addToCart.hasOwnProperty('deliveryInfoUrl') &&
                    payload.addToCart.deliveryInfoUrl) {
                    context.dispatch('setDeliveryInfoUrl', payload.addToCart.deliveryInfoUrl, {root: true});
                }
                if (!isMiniPdpMode && productInfo && payload.addToCart.hasOwnProperty('deliveryInfoSku') && payload.addToCart.deliveryInfoSku) {
                    context.dispatch('requestDeliveryInfo', {
                        groupId: productInfo.groupId,
                        varSku: payload.addToCart.deliveryInfoSku,
                        stock: payload.addToCart.hasStock,
                        groupStatus: productInfo.groupStatus
                    }, {root: true});
                }

                context.dispatch('updatePrice', {
                    price: productInfo.minPrice,
                    priceReference: productInfo.pricePartner,
                    bestPriceCoupon: productInfo.bestPriceCoupon,
                }, {root: true});
                // todo review update base stock label
                //context.dispatch('updateStockLabel', payload.basicInfo.stockMsg, {root: true});
                context.dispatch('updateHasStock', payload.basicInfo.hasStock, {root: true});

                // combos
                context.commit('setCanCheckCombos', !isMiniPdpMode && payload.addToCart.canCheckCombos);
                /*if (!isMiniPdpMode && payload.addToCart.canCheckCombos) {
                    context.dispatch('updateComboData', productInfo.groupId);
                }*/

                context.commit('setRelatedProductsBlocks', payload.relatedProducts);
                context.commit('setProductUnavailableBlocks', payload.productUnavailableBlocks);
                context.commit('setProductDetailBlocks', payload.productDetailBlocks);
                context.commit('setProductSocialBlocks', payload.productSocialBlocks);
                if(payload.updateDescription) {
                    context.commit('setUpdateDescription', payload.updateDescription);
                }
                if(payload.enableSideDetails) {
                    context.commit('setEnableSideDetails', payload.enableSideDetails);
                }

                if(payload.enableReverseSideDetails) {
                    context.commit('setEnableReverseSideDetails', payload.enableReverseSideDetails);
                }

                if(payload.enableStockAlert) {
                    context.commit('setEnableStockAlert', payload.enableStockAlert);
                }

                if(payload.productDetailBlocks && payload.productDetailBlocks.blockImageRecords) {
                    context.dispatch('updateBlockImageRecords', payload.productDetailBlocks.blockImageRecords);
                }

                // POINTS PURCHASE ENABLE!
                // get empty data for points button
                let btnPointsData = pdpUtils.buildPointsButtonData(null, null, null);
                //console.log('initWsData mobile: payload.enablePointsPurchase', payload.enablePointsPurchase)
                if(payload.hasOwnProperty('enablePointsPurchase')) {
                    // enable it
                    context.dispatch('updateEnablePointsPurchase', payload.enablePointsPurchase, {root: true});
                    if(payload.enablePointsPurchase){
                        // get points button data
                        btnPointsData = pdpUtils.buildPointsButtonData(null, payload.addToCart.products, productInfo.sku);
                        //console.log('initWsData mobile: btnPointsData', btnPointsData, payload.addToCart.products, productInfo.sku)
                    }
                }
                context.dispatch('addToCartMobile/updateFloatBtn', btnPointsData);

            } catch (e) {
                //console.log('page load failure!', e);
                if(typeof Bugsnag !== 'undefined'){
                    e = !(e instanceof Error) ? new Error(e) : e;
                    Bugsnag.notify('pdpSetData', e.message, {}, 'error');
                }
            } finally {
                context.dispatch('setLoading', false);
                if(!context.getters.miniPdpMode) {
                    context.dispatch('initMovingElementsBehaviour');
                }
            }

            // only works in good browsers wink wink
            /*if(screen.orientation && typeof screen.orientation.lock !== 'undefined'){
                screen.orientation.lock("portrait").catch(function(err) {
                    console.log(err);
                });
            }*/
        },
        setLoading(context, payload) {
            context.commit('isLoading', payload);
        },
        setLoadingCombos(context, payload) {
            context.commit('isLoadingCombos', payload);
        },
        updateLastOrderUrl(context, payload) {
            if(payload.canShowLastOrderDate) {
                setTimeout(() => {
                    context.commit('setLastOrderUrl', payload.lastOrderUrl);
                }, 1000);
            }
        },
        updateCriteoData(context, payload) {
            context.commit('setCriteoData', payload);
        },
        updateShowRotateDevice(context, payload) {
            context.commit('setShowRotateDevice', payload);
        },
        updateBlockImageRecords(context, payload) {
            context.commit('setBlockImageRecords', payload);
        },
        updateInfoSection(context, payload) {
            if(!isEmpty(payload)){
                context.commit('updateInfoSectionPartial', payload);
            }
        },
        updateBasicInfo(context, payload) {
            context.commit('setbasicInfoData', payload);
        },
        updateAddToCartData(context, payload) {
            context.commit('setAddToCartData', payload);
        },
        updateTabsData(context, payload) {
            context.commit('setTabsData', payload);
        },
        async updateComboData(context, payload) {
            context.commit('isLoadingCombos', true);
            const comboData = await apiCombos.getBlackRabbitComboById(payload.id, payload.blocksColor, payload.limit);
            if (comboData) {
                websiteEvents.eventCombo('show-block', 'PDP', null);
                context.commit('setComboData', comboData);
            } else { // ex: by changing groupId 
                context.commit('setComboData', null);
            }
            context.commit('isLoadingCombos', false);
        },
        async updateCampaignsData(context, payload) {
            if(payload){
                request.cancelLastCall(payload.url);
                const { data } = await request.get(payload.url,{id: payload.groupId});
                if(data && data.hasOwnProperty('campaigns')){
                    context.dispatch('quantityBuyStruct', data.quantityBuyStruct ? data.quantityBuyStruct : [], {root: true});
                    context.commit('setCampaignsData', data);
                }
            }
        },
        updateRelatedProductsBlocks(context, payload) {
            context.commit('setRelatedProductsBlocks', payload);
        }, 
        updateShowNavBar(context, payload) {
            context.commit('setShowNavBar', payload);
        },
        updateFixedNavbar(context, payload) {
            context.commit('setFixedNavbar', payload);
        },
        initMovingElementsBehaviour(context, payload) { // navbar && float (cart) button behaviour
            let lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;
            //let ticking = false;
            // moving elements
            //let cartBuyWidget = document.getElementById('cartBuyWidget');
            // viewport sections
            let mainPdpSection = document.getElementById('mainPdpSection');
            let isIOS = operatingSystem.isIOS();
            let throttleInterval = !isIOS ? 300 : 600;

            window.addEventListener('scroll', throttle(() => {
                // detects new state and compares it with the new one
                // navbar
                const scrollTopPosition = window.pageYOffset || document.documentElement.scrollTop;
                //let up = scrollTopPosition < lastScrollTop;
                //let diamondModal = document.getElementById('diamond-modal');

                if(!context.getters.fixedNavbar && (!context.getters['addToCartMobile/showOptionsPopup'] && !context.getters['addToCartMobile/showPagePopup'])) {
                    if (scrollTopPosition < 100) {
                        context.dispatch('updateShowNavBar', false);
                        context.dispatch('addToCartMobile/updateFloatBtn', {detached: false});
                    } else {
                        context.dispatch('updateShowNavBar', true);
                    }
                }
                
                if (!mainPdpSection) {
                    mainPdpSection = document.getElementById('mainPdpSection');
                } else {
                    if (utilities.isElementOutViewport(mainPdpSection, 0)) {
                       // console.log('out of viewport');
                        context.dispatch('addToCartMobile/updateFloatBtn', {detached: true});
                    } else {
                       // console.log('in viewport');
                        context.dispatch('addToCartMobile/updateFloatBtn', {detached: false});
                    }
                }
                
                // float button
                /*if (!cartBuyWidget) {
                    cartBuyWidget = document.getElementById('cartBuyWidget');
                } else {*/
                   
               /* }*/
                // saves the new position for iteration.
                lastScrollTop = scrollTopPosition <= 0 ? 0 : scrollTopPosition;
            }, throttleInterval));
            
        },
        reset(context){
            context.dispatch('addToCartMobile/reset');
            context.commit('reset');
        }
    },
    getters: {
        loadUrl: state => state.loadUrl,
        lastOrderUrl: state => state.lastOrderUrl,
        prozisPointsUpdateUrl: state => state.prozisPointsUpdateUrl,
        pointsUrl: state => state.pointsUrl,
        imagesUrl: state => state.imagesUrl,
        headerData: state => state.headerData,
        isLoading: state => state.isLoading,
        isLoadingCombos: state => state.isLoadingCombos,
        preloadImage: state => state.preloadImage,
        criteoData: state => state.criteoData,
        deviceDimensions: state => state.deviceDimensions,
        showRotateDevice: state => state.showRotateDevice,
        blockImageRecords: state => state.blockImageRecords,
        basicInfoData: state => state.basicInfoData,
        infoSectionData: state => state.infoSectionData,
        addToCartData: state => state.addToCartData,
        tabsData: state => state.tabsData,
        canCheckCombos: state => state.canCheckCombos,
        comboData: state => state.comboData,
        campaignsConnection: state => state.campaignsConnection,
        campaignsData: state => state.campaignsData,
        isAppStore: state => state.isAppStore,
        isAppAndroid: state => state.isAppAndroid,
        isAppIOS: state => state.isAppIOS,
        showNavBar: state => state.showNavBar,
        miniPdpMode: state => state.miniPdpMode,
        relatedProductsBlocks: state => state.relatedProductsBlocks,
        productUnavailableBlocks: state => state.productUnavailableBlocks,
        productDetailBlocks: state => state.productDetailBlocks,
        productSocialBlocks: state => state.productSocialBlocks,
        updateDescription: state => state.updateDescription,
        enableSideDetails: state => state.enableSideDetails,
        enableReverseSideDetails: state => state.enableReverseSideDetails,
        enableStockAlert: state => state.enableStockAlert,
        fixedNavbar: state => state.fixedNavbar,
    },
    modules: {
        addToCartMobile: moduleAddToCartMobile,
    }
};

export default pdpMobile;